import UnlimitedLengthTrialPlaceholder from '@/shared/assets/images/unlimited-length-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Unlock unlimited video length',
  bulletsHeader: '',
  buttonText: 'Unlock unlimited length',
  content: {
    allowedPlanNames: ['Creator Pro', 'Business'],
    chip: {
      title: 'Get full-length dubbing with other Pro tools',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'any content.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'What you’ll get',
      bullets: [
        'Dub videos of any length',
        'Export the full translated video',
        'Keep voice, timing, and background audio',
      ],
    },
  },
  features: [],
  media: {
    src: UnlimitedLengthTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'unlimitedLength' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'unlimitedLength' }),
  subtitle: 'Dub full videos, not just 1-minute trial previews',
};

export const UNLIMITED_LENGTH_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
